// extracted by mini-css-extract-plugin
export default {"container":"fB-z","brandName":"gB-z","productName":"hB-z","aboveGalleryInfo":"iB-z","belowGalleryInfo":"jB-z","breakLongProductName":"kB-z"};